<template>
  <div :class="$style.root">
    <div :class="$style.previewWrapper">
      <div :class="$style.previewContainer">
        <UserCharacter :class="$style.preview" />
        <div :class="$style.previewTitle">角色預覽</div>
      </div>
    </div>
    <template v-for="(group) in groupedItems" v-if="group.items.length > 0">
      <div :class="$style.groupTitle">
        {{ group.category.label }}
      </div>
      <template v-for="item in group.items">
        <slot name="item" :item="item"></slot>
      </template>
    </template>
    <div v-if="isEmpty" :class="$style.groupTitle">
      <div>你沒有已購買的物品</div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import UserCharacter from '@/components/UserCharacter'
import Item from './Item'

export default {
  components: {
    UserCharacter,
    Item,
  },
  computed: {
    isEmpty () {
      return this.purchasedItems.length == 0
    },
    groupedItems () {
      return this.categories.reduce((carry, category) => {
        return [ ...carry, {
          category,
          items: this.purchasedItems.filter((item) => this.checkCategory(category, item)),
        }]
      }, [])
    },
    ...mapGetters('shop', {
      purchasedItems: 'purchasedItems',
      categories: 'categories',
      checkCategory: 'checkCategory',
    }),
  },
  methods: {
    //
  },
}
</script>

<style lang="scss" module>
$preview-width: 220px;

.root {
  padding-right: $preview-width;
  @apply relative;
}

.groupTitle {
  @apply w-full;
  @apply mx-2;
  @apply mt-4;
  @apply font-bold;
  font-size: 1.5rem;
}

.previewWrapper {
  @apply absolute;
  @apply inset-y-0;
  right: -12px;
  width: $preview-width;
}

.previewContainer {
  position: sticky;
  @apply top-0;
  @apply py-8;
  @apply pl-2;
  box-shadow: -3px 3px 6px 0px rgba(0, 0, 0, 0.2);
}

.preview {
  width: 200px;
  height: 230px;
}

.previewTitle {
  font-size: 2rem;
  @apply text-center;
  @apply mt-4;
}
</style>
